import { Box } from '@mui/material'

const GradientBg = () => {
    return (
        <Box
            className="gradient-bg"
            sx={{
                overflow: "hidden",
                width: "99dvw",
                height: "100dvh",
                position: "fixed",
                zIndex: -2,
            }}
        >
            <Box sx={{
                width: "400px",
                height: "400px",
                backgroundColor: "#FC743A20",
                position: "absolute",
                borderRadius: "50%",
                filter: "blur(100px)",
                top: "40%",
                left: "4%",
                zIndex: -1,
            }}
            ></Box>

            <Box sx={{
                width: "400px",
                height: "400px",
                backgroundColor: "#A930FE20",
                position: "absolute",
                borderRadius: "50%",
                filter: "blur(100px)",
                top: "20%",
                left: "40%",
                zIndex: -1,
            }}
            ></Box>

            <Box sx={{
                width: "400px",
                height: "400px",
                backgroundColor: "#F9BC5210",
                position: "absolute",
                borderRadius: "50%",
                filter: "blur(100px)",
                top: "40%",
                right: "4%",
                zIndex: -1,
            }}
            ></Box>

        </Box>
    )
}

export default GradientBg